import React, { memo } from 'react';
import Link from 'next/link';

import { capitalizeFLetter } from '@/utils/helpers';
interface BreadcrumbProps {
  href: string;
  text: string;
}
function BreadcrumbList({ href, text }: BreadcrumbProps) {
  return (
    <li className="breadcrumb-item">
      <Link href={href}>
        <div>{capitalizeFLetter(text)}</div>
      </Link>
    </li>
  );
}
function BreadCrumb(props: any) {
  const { queryData } = props;

  const breadcrumbs = [
    {
      key: 'category',
      text: 'Indian Call Girls',
      href: `/${queryData.category || ''}`,
    },
    {
      key: 'state',
      text: queryData.state ? 'Call Girls In ' + capitalizeFLetter(queryData.state || '') : '',
      href: `/${queryData.category}/${queryData.state || ''}`,
    },
  ]
    .filter(({ text }) => text)
    .map(({ key, text, href }) => <BreadcrumbList key={key} href={href} text={text || ''} />);
  return (
    <nav className="breadcrumb-row">
      <ol className="breadcrumb mybrcrumb">
        <li className="breadcrumb-item homeIcon">
          <Link href="/">
            <i className="fa fa-home">
              <span className="bcseo-text">247Torax</span>
            </i>
          </Link>
        </li>
        {breadcrumbs}
      </ol>
    </nav>
  );
}

export default memo(BreadCrumb);
